let CareTypeService = function ($http, $rootScope) {

    var careTypeArray = [];

    /**
     * Get the list of care types
     */

    let data = function () {
        if (careTypeArray.length === 0) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
            careTypeArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.refcode/query?domain=CARE')
                .then(function (response) {
                    return response.data;
                });
        }

        return careTypeArray;
    }

    return { data };

};

export default CareTypeService;



// WEBPACK FOOTER //
// ./client/app/common/services/careType.service.js